// コマンド選択肢の共有定義
// CommandSettingsModal（編集側）・MapDetailCommandPanel（閲覧側）・
// AIMapGeneratorModal（生成条件）で共用する。
// 色は「実際にブロックとして出てくるときの色」に合わせる。
// 出どころは piecePreview/blockly/blocks（うごき #4C97FF / くりかえし #FFAB19）。
// ここを唯一の定義にして、画面ごとに色がばらつかないようにする。

import { BuilderCommandId } from "features/builder/types";

export interface CommandOption {
  id: BuilderCommandId;
  labelKey: string;
  category: string;
  /** 一覧に出すアイコン（Material Symbols） */
  icon: string;
}

export const COMMAND_OPTIONS: CommandOption[] = [
  // うごき
  {
    id: BuilderCommandId.MOVE_FORWARD,
    labelKey: "MSG_BUILDER_COMMAND_MOVE_FORWARD",
    category: "motion",
    icon: "arrow_upward",
  },
  {
    id: BuilderCommandId.TURN_LEFT,
    labelKey: "MSG_BUILDER_COMMAND_TURN_LEFT",
    category: "motion",
    icon: "turn_left",
  },
  {
    id: BuilderCommandId.TURN_RIGHT,
    labelKey: "MSG_BUILDER_COMMAND_TURN_RIGHT",
    category: "motion",
    icon: "turn_right",
  },
  {
    id: BuilderCommandId.JUMP,
    labelKey: "MSG_BUILDER_COMMAND_JUMP",
    category: "motion",
    icon: "keyboard_double_arrow_up",
  },
  // くりかえし
  {
    id: BuilderCommandId.LOOP,
    labelKey: "MSG_BUILDER_COMMAND_LOOP",
    category: "control",
    icon: "repeat",
  },
  {
    id: BuilderCommandId.IF_COLOR,
    labelKey: "MSG_BUILDER_COMMAND_IF_COLOR",
    category: "control",
    icon: "alt_route",
  },
  {
    id: BuilderCommandId.WHILE_COLOR,
    labelKey: "MSG_BUILDER_COMMAND_WHILE_COLOR",
    category: "control",
    icon: "sync",
  },
];

export interface CommandCategory {
  id: string;
  labelKey: string;
  /** 選択中の行の枠線・文字色 */
  accentClass: string;
  borderClass: string;
  /** 選択中の行の背景（薄い色）*/
  bgClass: string;
}

export const COMMAND_CATEGORIES: CommandCategory[] = [
  {
    id: "motion",
    labelKey: "MSG_BUILDER_COMMAND_CATEGORY_MOTION",
    accentClass: "text-[#4C97FF]",
    borderClass: "border-[#4C97FF]",
    bgClass: "bg-[#4C97FF]/10",
  },
  {
    id: "control",
    labelKey: "MSG_BUILDER_COMMAND_CATEGORY_CONTROL",
    accentClass: "text-[#FFAB19]",
    borderClass: "border-[#FFAB19]",
    bgClass: "bg-[#FFAB19]/10",
  },
];
